import { useEffect } from 'react'

const SITE_NAME = 'CJM Studios'
const DEFAULT_DESCRIPTION = 'CJM Studios is a Brisbane web design and development studio building custom websites, online stores, web apps and software for small businesses across Australia.'

// Updates the tab title + meta/OG tags per route. Note: this only helps
// clients that execute JS (browsers, Googlebot) — link-preview scrapers
// (Slack, Discord, iMessage, etc.) read the static tags in index.html
// before any JS runs, so they'll always show the homepage's OG values for
// any URL on this site. Fixing that needs prerendering/SSR, out of scope here.
// noindex: for pages that must never show in search (the 404) — tells search
// engines to skip it and drops the canonical so it can't point anywhere real.
export function usePageMeta(title, description = DEFAULT_DESCRIPTION, { noindex = false } = {}) {
  useEffect(() => {
    const fullTitle = title ? `${title} | ${SITE_NAME}` : `${SITE_NAME} — Web Design & Development Studio in Brisbane`
    document.title = fullTitle

    const setContent = (selector, value) => {
      const el = document.querySelector(selector)
      if (el) el.setAttribute('content', value)
    }

    setContent('meta[name="description"]', description)
    setContent('meta[property="og:title"]', fullTitle)
    setContent('meta[property="og:description"]', description)
    setContent('meta[property="og:url"]', window.location.href)
    setContent('meta[name="twitter:title"]', fullTitle)
    setContent('meta[name="twitter:description"]', description)

    const canonical = document.querySelector('link[rel="canonical"]')
    if (noindex) {
      canonical?.remove()
      let robots = document.querySelector('meta[name="robots"]')
      if (!robots) {
        robots = document.createElement('meta')
        robots.setAttribute('name', 'robots')
        document.head.appendChild(robots)
      }
      robots.setAttribute('content', 'noindex')
    } else if (canonical) {
      canonical.setAttribute('href', window.location.origin + window.location.pathname)
    }
  }, [title, description, noindex])
}
